import React from "react";
import * as S from "./styled";

export type BreadcrumbItemType = {
    title: string;
    url: string;
}

type Props = {
 items: BreadcrumbItemType[];
}

const Breadcrumbs: React.FC<Props> = ({items}) => {

    return (
        <S.List>
            {items.map((item, idx) => (
                <S.Item key={item.title}>
                    {idx === items.length - 1 ? (
                        <S.ActiveBreadcrumb>{item.title}</S.ActiveBreadcrumb>
                    ) : (
                        <S.CustomLink href={item.url}>{item.title}</S.CustomLink>
                    )}
                </S.Item>
            ))}
        </S.List>
    );
};

export default Breadcrumbs;